import React, { useState, useEffect } from "react";
import {
  Typography,
  IconButton,
  Avatar,
  AppBar,
  Toolbar,
  Menu,
  MenuItem,
  Badge,
  Slide,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
  Grid,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Notifications, CalendarToday } from "@mui/icons-material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import { getLogout } from "../../store/actions/userActions";
import { useNavigate } from "react-router-dom";
import { useFetch } from "../../hooks";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";

const AppHeaderBar = ({ title, onBackScreenName }) => {
  const userDetails = useSelector((state) => state?.user?.userdetails);
  const userId = userDetails?.vtype === "user" ? userDetails["user_id"] : null;
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      title: "Media and Promotion admin screens",
      date: "Yesterday",
      user: "Vasanth Kumar",
      status: "Completed",
      unread: true,
    },
    {
      id: 2,
      title: "Varent properties need add Search",
      date: "26 Jan 2025",
      user: "Gnanesh Gn",
      status: "Completed",
      unread: true,
    },
    {
      id: 3,
      title: "ALL product management flows",
      date: "26 Jan 2025",
      user: "Gnanesh Gn",
      status: "Completed",
      unread: true,
    },
    {
      id: 4,
      title: "Financial Management screens",
      date: "26 Jan 2025",
      user: "Latha Kumpatla",
      status: "Completed",
      unread: false,
    },
    {
      id: 5,
      title: "Add products flows APIs integration",
      date: "26 Jan 2025",
      user: "Gnanesh Gn",
      status: "Completed",
      unread: false,
    },
    {
      id: 6,
      title: "Admin dashboard screens",
      date: "22 Jan 2025",
      user: "Simhachalam Konari",
      status: "Timeblock updated",
      unread: false,
    },
  ]);
  const [showSnackBar, setShowSnackBar] = useState({
    showsnack: false,
    message: "",
  });
  //const apptoken = useSelector((state) => state.user.apptoken);
  const apptoken = useSelector((state) => state.user.logintoken);
  console.log("apptoken", apptoken);
  const dispatch = useDispatch();
  //Handle Logout
  const handleLogout = async () => {
    await fetchData();
  };
  const [anchorNotif, setAnchorNotif] = useState(null);
  const [anchorProfile, setAnchorProfile] = useState(null);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate(); // Initialize navigation

  const {
    data: logoutData,
    error: logoutError,
    isLoading: isLoadingLogout,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("logout"), {
    method: "GET",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    if (logoutData && logoutData["status"] === true) {
      localStorage.removeItem("logintoken");
      dispatch(getLogout({ type: "LOGOUT" }));
      setShowSnackBar({
        ...showSnackBar,
        showsnack: true,
        message: logoutData["message"],
      });
      setTimeout(() => {
        navigate("/sal");
      }, 2000);
    } else if (logoutData) {
    }
  }, [logoutData, logoutError]);

  const handleNotifOpen = (event) => {
    setAnchorNotif(event.currentTarget);
  };

  const handleNotifClose = () => {
    setAnchorNotif(null);
  };

  const markAsRead = (id) => {
    setNotifications(
      notifications.map((notif) =>
        notif.id === id ? { ...notif, unread: false } : notif,
      ),
    );
  };

  const clearNotifications = () => {
    setNotifications([]);
  };

  const handleProfileOpen = (event) => {
    setAnchorProfile(event.currentTarget);
  };

  const handleProfileClose = () => {
    setAnchorProfile(null);
  };

  const handleProfileSetting = () => {
    setAnchorProfile(null); // Close the menu
    // navigate("/admin-profile"); // Navigate to the profile settings screen
    onBackScreenName("Profile");
  };
  return (
    <AppBar
      position="static"
      elevation={2}
      sx={{
        borderBottom: "1px solid #ddd",
        mb: 2,
        backgroundColor: "white",
        color: "black",
        borderRadius: "20px",
      }}
    >
      <Snackbar
        open={showSnackBar.showsnack}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        TransitionComponent={Slide}
      >
        <MuiAlert severity={snackbarSeverity} sx={{ width: "100%" }}>
          {showSnackBar.message}
        </MuiAlert>
      </Snackbar>
      <Toolbar>
        <Typography variant="h6" noWrap sx={{ flexGrow: 1 }} fontWeight="bold">
          {title}
        </Typography>

        {/* Notifications */}
        <IconButton onClick={handleNotifOpen}>
          <Badge
            badgeContent={notifications.filter((n) => n.unread).length}
            color="error"
          >
            <NotificationsIcon />
          </Badge>
        </IconButton>

        <Menu
          anchorEl={anchorNotif}
          open={Boolean(anchorNotif)}
          onClose={handleNotifClose}
          PaperProps={{
            sx: {
              width: { xs: "calc(100vw - 32px)", sm: 420 },
              maxWidth: "100%",
              maxHeight: "500px",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
            },
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 16px",
              backgroundColor: "#f5f5f5",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Notifications
            </Typography>
            <Button
              onClick={clearNotifications}
              size="small"
              sx={{
                textTransform: "none",
                color: "#1976d2",
                fontWeight: "500",
              }}
            >
              Clear All
            </Button>
          </Box>
          <Divider />

          {/* Notification List */}
          <List
            sx={{
              maxHeight: "450px",
              overflowY: "auto",
              padding: "0",
              // Hide scrollbar
              "&::-webkit-scrollbar": {
                display: "none", // For Chrome, Safari, and Edge
              },
              msOverflowStyle: "none", // For Internet Explorer and Edge
              scrollbarWidth: "none", // For Firefox
            }}
          >
            {notifications.length > 0 ? (
              notifications.map((notif) => (
                <MenuItem
                  key={notif.id}
                  onClick={() => markAsRead(notif.id)}
                  sx={{
                    padding: "12px 16px",
                    background: notif.unread ? "#E3F2FD" : "white",
                    "&:hover": {
                      backgroundColor: notif.unread ? "#D0E6FA" : "#f9f9f9",
                    },
                  }}
                >
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={10}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: notif.unread ? "bold" : "normal" }}
                      >
                        {notif.title}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "gray" }}>
                        {notif.user} changed the task status to {notif.status}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ color: "#616161", fontSize: "12px" }}
                      >
                        {notif.date}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      {notif.unread && <InfoIcon color="primary" />}
                    </Grid>
                  </Grid>
                </MenuItem>
              ))
            ) : (
              <Typography
                variant="body2"
                sx={{ padding: "16px", textAlign: "center", color: "#757575" }}
              >
                No new notifications
              </Typography>
            )}
          </List>
        </Menu>

        {/* Profile */}
        <Avatar
          alt="Gn"
          src="/profile.webp"
          sx={{ ml: 2 }}
          onClick={handleProfileOpen}
        />
        <Menu
          anchorEl={anchorProfile}
          open={Boolean(anchorProfile)}
          onClose={handleProfileClose}
        >
          {!userId && (
            <MenuItem onClick={handleProfileSetting}>Profile Setting</MenuItem>
          )}
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};
export default AppHeaderBar;
